import React from 'react';
import { Carousel, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const slides = [
    {
        image: "/building_resilient_communities.png",
        title: "Building Resilient Communities",
        subtitle: "Transforming lives across rural Maharashtra"
    },
    {
        image: "/Empowering_Rural_Communities.png",
        title: "Green Livelihoods",
        subtitle: "Biodegradable leaf plate initiative in Sindhudurg"
    },
    {
        image: "/Harmonious_Coexistence.png",
        title: "Human–Wildlife Coexistence",
        subtitle: "Mitigating conflicts through community-led conservation"
    },
    {
        image: "/traning_center.png",
        title: "PSGS Training Center",
        subtitle: "A hub for learning, capacity building & collaboration"
    },
    {
        image: "/drinking_water.png",
        title: "Drinking Water Sustainability",
        subtitle: "Ensuring water security for rural communities"
    },
    {
        image: "/farmer_to_entrepranures.png",
        title: "Women Entrepreneurship",
        subtitle: "From farmers to entrepreneurs — empowering rural women"
    }
];

const pairs = [];
for (let i = 0; i < slides.length; i += 2) {
    pairs.push(slides.slice(i, i + 2));
}

const CarouselHome = () => {
    return (
        <div style={{ backgroundColor: '#f0f4f0' }}>
            <Carousel
                interval={5000}
                pause="hover"
                indicators={true}
                controls={true}
                className="carousel-two-col"
            >
                {pairs.map((pair, pairIndex) => (
                    <Carousel.Item key={pairIndex}>
                        <Row className="g-2" style={{ padding: '4px' }}>
                            {pair.map((slide, index) => (
                                <Col md={6} key={index}>
                                    <div style={{
                                        position: 'relative',
                                        overflow: 'hidden',
                                        borderRadius: '8px',
                                        height: '340px',
                                        backgroundColor: '#e8ece8'
                                    }}>
                                        <img
                                            src={slide.image}
                                            alt={slide.title}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                display: 'block',
                                                objectFit: 'cover',
                                                objectPosition: 'center'
                                            }}
                                        />
                                        <div style={{
                                            position: 'absolute',
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            padding: '24px 16px 14px',
                                            background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0) 100%)'
                                        }}>
                                            <h5 style={{
                                                color: '#fff',
                                                fontWeight: '700',
                                                fontSize: 'clamp(0.9rem, 1.8vw, 1.15rem)',
                                                marginBottom: '2px',
                                                textShadow: '1px 1px 3px rgba(0,0,0,0.6)'
                                            }}>
                                                {slide.title}
                                            </h5>
                                            <p style={{
                                                color: 'rgba(255,255,255,0.9)',
                                                fontSize: 'clamp(0.75rem, 1.2vw, 0.9rem)',
                                                marginBottom: 0,
                                                textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                                            }}>
                                                {slide.subtitle}
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
};

export default CarouselHome;
